
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iULSi", function(module, exports) {
'use strict';
async function $dc5297e54d948340$export$8134c072fddab6a5(url) {
    try {
        const response = await fetch(url);
        if (response.ok) {
            const data = await response.json();
            return data;
        }
    } catch (error) {
        console.log(`Error: ${error}`);
    }
}

});

parcelRegister("b4xNq", function(module, exports) {

$parcel$export(module.exports, "renderMovies", () => $80fa48a1974db74a$export$1a30573fde3dfc62);
'use strict';
// ital für Darsteller, Dauer, Regie
const $80fa48a1974db74a$export$1a30573fde3dfc62 = (data, page = 1, actorList = 'Darsteller', length = 'Dauer', director = 'Regie')=>{
    const timerStart = Date.now();
    const fragment = document.createDocumentFragment();
    page--;
    const maxItems = 25;
    let start = maxItems * page;
    let end = start + maxItems;
    let paginatedItems = data.slice(start, end);
    paginatedItems.map((ele, i)=>{
        const listItem = document.createElement('li');
        listItem.className = "list-item";
        // create and append image-element
        const imgWrapper = document.createElement('div');
        imgWrapper.className = "image-wrapper";
        listItem.appendChild(imgWrapper);
        if (ele.image) {
            const image = document.createElement('img');
            image.setAttribute('src', `${ele.image}`);
            image.setAttribute('alt', `${ele.title}`);
            image.setAttribute('onerror', `this.onerror=null;this.src='';`);
            image.className = "item-image";
            imgWrapper.appendChild(image);
        }
        // infoContainer
        const infoContainer = document.createElement('div');
        infoContainer.className = "info-container";
        listItem.appendChild(infoContainer);
        // header
        const header = document.createElement('header');
        header.className = 'item-header';
        infoContainer.appendChild(header);
        // screeningDate
        const screeningDate = document.createElement('span');
        screeningDate.textContent = `${ele.screeningDate}, ${ele.screeningTime} Uhr`;
        header.appendChild(screeningDate);
        // name
        const itemTitle = document.createElement('h2');
        itemTitle.textContent = ele.title.toUpperCase();
        itemTitle.style.marginBottom = "0px";
        header.appendChild(itemTitle);
        // country and year
        const countryAndYear = document.createElement('span');
        countryAndYear.textContent = `${ele.country} ${ele.releaseYear}, `;
        header.appendChild(countryAndYear);
        const runtime = document.createElement('span');
        runtime.textContent = `${length}: ${ele.runtime} min, `;
        header.appendChild(runtime);
        // director and version
        const directorAndVersion = document.createElement('strong');
        directorAndVersion.textContent = `${director}: ${ele.director} - ${ele.version}`;
        header.appendChild(directorAndVersion);
        // actorsContainer
        const actorsContainer = document.createElement('div');
        actorsContainer.className = 'actors-container';
        infoContainer.appendChild(actorsContainer);
        // actors
        const actors = document.createElement('span');
        const strong = document.createElement('strong');
        strong.textContent = `${actorList}: `;
        actors.textContent = ele.actors;
        actorsContainer.appendChild(strong);
        actorsContainer.appendChild(actors);
        // Strong Copy Text
        if (ele.subtitle) ele.subtitle.map((p)=>{
            const subtitle = document.createElement('p');
            subtitle.className = "strong-paragraph";
            subtitle.textContent = p;
            infoContainer.appendChild(subtitle);
        });
        // Copy Text
        if (ele.bodycopy) ele.bodycopy.map((p)=>{
            const bodyCopy = document.createElement('p');
            bodyCopy.className = "paragraph";
            bodyCopy.textContent = p;
            infoContainer.appendChild(bodyCopy);
        });
        fragment.appendChild(listItem);
    });
    const duration = Date.now() - timerStart;
    // console.log(`duration: ${duration}`);
    return fragment;
};

});

parcelRequire("iULSi");

var $b4xNq = parcelRequire("b4xNq");
var $a113b4978f99907a$exports = {};
$a113b4978f99907a$exports = JSON.parse('[{"title":"LA GRAZIA","director":"Paolo Sorrentino","country":"Italia","releaseYear":2025,"runtime":131,"version":"OmU","screeningDate":"17.09.2026","readableDate":"2026-09-17","screeningTime":"20:00","actors":"Toni Servillo, Anna Ferzetti, Orlando Cinque, Massimo Venturiello, Milvia Marigliano e altri","subtitle":["Un presidente della Repubblica Italiana alla fine del suo mandato. Con LA GRAZIA Paolo Sorrentino ha scelto nuovamente una figura potente quale specchio per affrontare questioni morali ed esistenziali. Mariano De Santis deve decidere se firmare una legge sulla cosiddetta eutanasia e due richieste di grazia, mentre lo tormenta il ricordo della moglie deceduta: un dramma politico che conseguentemente ricade nel privato."],"bodycopy":["Un tema che si allinea chiaramente ai precedenti film di Sorrentino. Gi\xe0 in IL DIVO (2008) o in LORO (2018) si interessa meno per l\'analisi politica quanto per lo stato d\'animo dei potenti: la solitudine, la messa in scena di se stessi e la coscienza del passato. LA GRAZIA si riallaccia pure a quella malinconica ricerca della bellezza che caratterizza le sue opere gi\xe0 da LA GRANDE BELLEZZA. Anche formalmente Sorrentino punta sulla continuit\xe0: di nuovo lavora con Toni Servillo, il suo protagonista da molti anni. Quindi LA GRAZIA, che ha inaugurato la Biennale Cinema 2025 a Venezia, non rappresenta una rottura, ma un\'intensificazione dei temi principali di Sorrentino: il potere quale palcoscenico e la coscienza quale abisso."],"image":"../La grazia.jpg"},{"title":"LA GRANDE BELLEZZA","director":"Paolo Sorrentino","country":"Francia, Italia","releaseYear":2013,"runtime":147,"version":"OmU","screeningDate":"15.10.2026","readableDate":"2026-10-15","screeningTime":"20:00","actors":"Toni Servillo, Carlo Verdone, Sabrina Ferilli, Carlo Buccirosso, Iaia Forte e altri","subtitle":["Una tempesta di immagini, melanconia e struggente nostalgia che nel film compongono il ritratto penetrante di un uomo inquieto vagante tra magnificenza e vuoto. Paolo Sorrentino crea un panorama caleidoscopico di Roma servendosi della persona di un autore invecchiato che, passando da splendide feste ad incontri insensati in viuzze abbandonate, scandaglia la \\"grande bellezza\\" sfuggente cercando di dar senso alla sua vita."],"bodycopy":["LA GRANDE BELLEZZA affronta i temi della fugacit\xe0, dei ricordi e del continuo oscillare tra superficialit\xe0 pubblica e vuoto interiore. Le sue immagini opulente e il ritmo del montaggio si associano alla riflessione e all\'ironia creando uno studio visivo su arte, vita e ideali perduti. Nel linguaggio tematico di Sorrentino si individua un tema ricorrente: la ricerca di un significato in un mondo tra apparenza ed esistenza.","Confrontando questo film con la sua nuova pellicola LA GRAZIA si nota lo spostamento dalla ricerca della bellezza verso la responsabilit\xe0 individuale e l\'introspezione di fronte alle sfide morali, ma in fondo rimane fedele al suo impegno di riflettere sull\'esistenza umana."],"image":"../La grande bellezza.jpg"},{"title":"SOTTO LE NUVOLE","director":"Gianfranco Rosi","country":"Italia, Francia","releaseYear":2025,"runtime":114,"version":"OmU","screeningDate":"19.11.2026","readableDate":"2026-11-19","screeningTime":"20:00","actors":"Tecla Insolia, Michele Riondino, Fabrizia Sacchi, Andrea Pennacchi, Valentina Bell\xe8 e altri","subtitle":["Passato e presente, carne e cenere, l\'immenso e il microscopico: il documentario di Gianfranco Rosi, premiato a Venezia, \xe8 uno studio dei contrasti estremi. Nello scenario del Vesuvio attivo, tra il bianco osseo e un nero vellutato, ricerca le geometrie elementari della vita."],"bodycopy":["\u201CSotto una coltre di nubi grigio-bianche si avverte la minaccia del vulcano. Grandi nubi fumanti entrano nello schermo e lo occupano con le loro forme bizzarre e con la lava incandescente che sgorga dalle profondit\xe0 della terra. Mentre nel golfo di Napoli la vita frenetica prosegue come di solito con i suoi abitanti indaffarati nelle loro mansioni quotidiane, tutta l\'area sembra avvolta da un clima di incertezza presagente una sventura. Il vulcano in SOTTO LE NUVOLE preannuncia una lunga serie di altre crisi. Nell\'opera di Gianfranco Rosi le forze elementari e il bagaglio storico si intrecciano tra di loro\u201D. (Sophia Satchell-Baeza)"],"image":"../Sotto le nuvole.jpg"},{"title":"PRIMAVERA","director":"Damiano Michieletto","country":"Italia, Francia","releaseYear":2025,"runtime":110,"version":"OmU","screeningDate":"17.12.2026","readableDate":"2026-12-17","screeningTime":"20:00","actors":"Tecla Insolia, Michele Riondino, Fabrizia Sacchi, Andrea Pennacchi, Valentina Bell\xe8 e altri","subtitle":["Cecilia, una valente violinista, cresce nella Venezia del 18\xb0 secolo in un orfanotrofio femminile, l\'Ospedale della Piet\xe0, in cui le ragazze ricevono un\'educazione musicale tale da rendere la loro orchestra rinomata a livello mondiale. Durante i concerti offerti a benefattori generosi Cecilia rimane sempre nascosta dietro una maschera: non deve essere individuata come persona autonoma. Per\xf2 con l\'arrivo di un nuovo maestro ha per la prima volta l\'opportunit\xe0 di uscire dalle ristrettezze della sua vita attuale e sfuggire ad un matrimonio arrangiato. Antonio Vivaldi, il nuovo direttore dell\'orchestra, la incoraggia a prendere la sua strada."],"bodycopy":["PRIMAVERA racconta la storia di una donna che si emancipa nell\'atmosfera veneziana dell\'epoca barocca, sottolineata dalla musica vivaldiana. Damiano Micheletto, registra di teatro e d\'opera, in questo suo primo film intreccia la biografia del famosissimo compositore con il destino di una giovane orfana che nella musica trova l\'ispirazione per prendere la vita nelle proprie mani."],"image":"../Primavera.jpg"}]');


// const path = './JSON/programma.json';
// let data = [];
const $f008251071bd7097$var$movieContainer = document.querySelector(".movie-container");
// async function getFetchedData() {
//     let data = await fetchData(path);;
//     return data;
// }
// data.push(await getFetchedData());
// let movies = data[0];
$f008251071bd7097$var$movieContainer.appendChild((0, $b4xNq.renderMovies)((0, (/*@__PURE__*/$parcel$interopDefault($a113b4978f99907a$exports))), 1, "Attori", "Durata", "Regia")); // pagination.appendChild(createPagination(movies, 1));


//# sourceMappingURL=contatto.ec8514ee.js.map
